import React from 'react';
import { Icon } from '@ohif/ui';

interface NavigationButtonProps {
    onNavigate: () => void;
    isVisible: boolean;
    direction?: 'next' | 'previous';
    className?: string;
}

const NavigationButton: React.FC<NavigationButtonProps> = ({
    onNavigate,
    isVisible,
    direction = 'next',
    className = ''
}) => {
    if (!isVisible) return null;

    const iconName = direction === 'next' ? 'chevron-right' : 'chevron-left';
    const label = direction === 'next' ? 'Next Field' : 'Previous Field';

    return (
        <div className={`absolute bottom-6 right-6 z-50 group ${className}`}>
            <button
                onClick={onNavigate}
                aria-label={label}
                title={label}
                className="bg-blue-600 hover:bg-blue-700 text-white p-3 rounded-full shadow-lg transition duration-300 ease-in-out"
                type="button"
            >
                <Icon name={iconName} className="w-6 h-6" />
            </button>
        </div>
    );
};

export default NavigationButton;
